// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_R1j","cls2":"ProfileDropdown-cls2_WnM ProfileDropdown-cls1_R1j"};